import React, { Fragment } from 'react'
import AssetsRptFormView from '../../../../components/account/report/assets_rpt/AssetsRptFormView'

const AccountAssetsReportFormView = () => {
  return (
    <Fragment><AssetsRptFormView /></Fragment>
  )
}

export default AccountAssetsReportFormView